'use strict';

module.exports = {
    DASHBOARD: {number: 1, path: "/"},

    // NOTIFICATION PAGES
    N_STOLEN_PASSWORD_DIRECT_CLIENT: {number: 46, path: "/stolen-password-direct-client"},
    N_STOLEN_PASSWORD_DIRECT_EMPLOYEE: {number: 2, path: "/stolen-password-direct-employee"},
    N_STOLEN_PASSWORD_3RD: {number: 3, path: "/stolen-password-3rd-party"},
    N_TARGETED_MALWARE: {number: 4, path: "/targeted-malware"},
    N_TARGETED_PHISHING_SITE: {number: 5, path: "/targeted-phishing-site"},
    N_TARGETED_PHISHING_EMAIL: {number: 6, path: "/targeted-phishing-email"},
    N_MALWARE_HOSTING: {number: 7, path: "/malware-hosting"},
    N_DECEPTIVE_PHISHING_HOSTING: {number: 8, path: "/deceptive-phishing-hosting"},
    N_C_C_HOSTING: {number: 9, path: "/cc-hosting"},
    N_PHISHING_RECEIVED: {number: 10, path: "/phishing-received"},
    N_BOTNET_MEMBER: {number: 11, path: "/botnet-member"},
    N_TARGETED_SOFTWARE: {number: 12, path: "/targeted-software"},
    N_SPAM_SENDER: {number: 13, path: "/spam-sender"},
    N_DROP_SITES_FOR_LOGS_OR_STOLEN_CREDENTIALS: {number: 14, path: "/drop-sites"},
    N_KNOWN_COMPROMISED_HOSTILE_SERVERS: {number: 15, path: "/known-compromised-hostile-servers"},
    N_PUA_HOSTING: {number: 16, path: "/pua-hosting"},
    N_THREAT_SCORE: {number: 63, path: "/threat-score"},

    // GLOBAL THREAT PAGES
    GL_TARGETED_MALWARE: {number: 17, path: "/global-targeted-malware"},
    GL_TARGETED_PHISHING_SITE: {number: 18, path: "/global-targeted-phishing-site"},
    GL_TARGETED_PHISHING_EMAIL: {number: 19, path: "/global-targeted-phishing-email"},
    GL_MALWARE_HOSTING: {number: 20, path: "/global-malware-hosting"},
    GL_DECEPTIVE_PHISHING_HOSTING: {number: 21, path: "/global-deceptive-phishing-hosting"},
    GL_C_C_HOSTING: {number: 22, path: "/global-cc-hosting"},
    GL_PHISHING_RECEIVED: {number: 23, path: "/global-phishing-received"},
    GL_BOTNET_MEMBER: {number: 24, path: "/global-botnet-member"},
    GL_TARGETED_SOFTWARE: {number: 25, path: "/global-targeted-software"},
    GL_SPAM_SENDER: {number: 26, path: "/global-spam-sender"},
    GL_DROP_SITES_FOR_LOGS_OR_STOLEN_CREDENTIALS: {number: 27, path: "/global-drop-sites"},
    GL_KNOWN_COMPROMISED_HOSTILE_SERVERS: {number: 28, path: "/global-known-compromised-hostile-servers"},
    GL_PUA_HOSTING: {number: 29, path: "/global-pua-hosting"},

    SETTINGS: {number: 30, path: "/settings"},

    VERDICT_AND_KILLCHAIN: {number: 100, path: "/search-results"},

    // PARTNER PAGES
    PA_STOLEN_PASSWORD_DIRECT: {number: 60, path: "/partner-stolen-password-direct-client"},
    PA_STOLEN_PASSWORD_EMPLOYEE: {number: 61, path: "/partner-stolen-password-direct-employee"},
    PA_STOLEN_PASSWORD_3RD: {number: 62, path: "/partner-stolen-password-3rd-party"},
    PA_TARGETED_MALWARE: {number: 33, path: "/partner-targeted-malware"},
    PA_TARGETED_PHISHING_SITE: {number: 34, path: "/partner-targeted-phishing-site"},
    PA_TARGETED_PHISHING_EMAIL: {number: 35, path: "/partner-targeted-phishing-email"},
    PA_MALWARE_HOSTING: {number: 36, path: "/partner-malware-hosting"},
    PA_DECEPTIVE_PHISHING_HOSTING: {number: 37, path: "/partner-deceptive-phishing-hosting"},
    PA_C_C_HOSTING: {number: 38, path: "/partner-cc-hosting"},
    PA_PHISHING_RECEIVED: {number: 39, path: "/partner-phishing-received"},
    PA_BOTNET_MEMBER: {number: 40, path: "/partner-botnet-member"},
    PA_TARGETED_SOFTWARE: {number: 41, path: "/partner-targeted-software"},
    PA_SPAM_SENDER: {number: 42, path: "/partner-spam-sender"},
    PA_DROP_SITES_FOR_LOGS_OR_STOLEN_CREDENTIALS: {number: 43, path: "/partner-drop-sites"},
    PA_KNOWN_COMPROMISED_HOSTILE_SERVERS: {number: 44, path: "/partner-known-compromised-hostile-servers"},
    PA_PUA_HOSTING: {number: 45, path: "/partner-pua-hosting"},

    // INDUSTRY PAGES
    IN_TARGETED_MALWARE: {number: 47, path: "/industry-targeted-malware"},
    IN_TARGETED_PHISHING_SITE: {number: 48, path: "/industry-targeted-phishing-site"},
    IN_TARGETED_PHISHING_EMAIL: {number: 49, path: "/industry-targeted-phishing-email"},
    IN_MALWARE_HOSTING: {number: 50, path: "/industry-malware-hosting"},
    IN_DECEPTIVE_PHISHING_HOSTING: {number: 51, path: "/industry-deceptive-phishing-hosting"},
    IN_C_C_HOSTING: {number: 52, path: "/industry-cc-hosting"},
    IN_PHISHING_RECEIVED: {number: 53, path: "/industry-phishing-received"},
    IN_BOTNET_MEMBER: {number: 54, path: "/industry-botnet-member"},
    IN_TARGETED_SOFTWARE: {number: 55, path: "/industry-targeted-software"},
    IN_SPAM_SENDER: {number: 56, path: "/industry-spam-sender"},
    IN_DROP_SITES_FOR_LOGS_OR_STOLEN_CREDENTIALS: {number: 57, path: "/industry-drop-sites"},
    IN_KNOWN_COMPROMISED_HOSTILE_SERVERS: {number: 58, path: "/industry-known-compromised-hostile-servers"},
    IN_PUA_HOSTING: {number: 59, path: "/industry-pua-hosting"},
};



// WEBPACK FOOTER //
// ./src/utils/page-number-constants.js